import { _ } from "extensions/underscore";
import { Backbone } from "extensions/backbone";
import { v4 as uuid } from "uuid";

import {
    PazienError
} from "common/helpers/errors";

import { pazienHistory } from "common/components/pazienHistory";
import { removeQueryStringParameter } from "common/helpers/removeQueryStringParameter";

export const TabModel = Backbone.Model.extend({
    defaults: () => ({
        name: "New tab",
        fragment: "",
        history: true, // Does the tab support fragment change? `true` by default
        newTab: false,
        active: true,
        canClose: false, // Master tab cannot be closed
        view: void 0, // View class
        viewOptions: {} // View options for the view class when instantiating
    }),
    
    initialize() {
        this.setID();
        this.updateTabFragment();
    },
    
    setID() {
        if (!this.get("id")) {
            const tabID = uuid();
            this.set("id", `tab-${tabID}`); // Add `tab` prefix as ID's starting with number are not legal according to w3c standards
        }
    },
    
    updateTabFragment() {
        if (this.get("history")) {
            this.set("fragment", removeQueryStringParameter(this.get("fragment")));
        }
    },
    
    /**
     * Convert tab fragment to matching view
     * This functionality can break with updating to a newer version of Backbone.
     *
     * @returns {*}
     */
    getTabViewByFragment() {
        if (this.get("history")) {
            const fragment = this.get("fragment");
            const handler = this.get("handler");
            const fragmentParser = this.get("fragmentParser");
            const normalizedFragment = pazienHistory.addParamsToFragment(fragment);
            
            if (!handler || !fragmentParser) {
                return void 0;
            }

            // NOTE MATT: Because reconciliation2 is the only product using this feature, let reconciliation2 determine how the method is called.
            const view = handler({ viewOnly: true }, ...fragmentParser(normalizedFragment));
            
            if (view === null) {
                throw new Error(`Handler for route ${fragment} does not support 'viewOnly: true' options`);
            }
            
            if (typeof view === "undefined") {
                throw new PazienError({
                    message: "Cannot proceed with undefined view for a tab fragment",
                    extra: {
                        normalizedFragment
                    }
                });
            }
            
            if (view.then) {
                return view.then((v) => {
                    v.tabID = this.get("id");
                    return v;
                });
            }
            view.tabID = this.get("id");
            return view;
        }
    },
    
    getTabView() {
        const hasHistorySupport = this.get("history");
        const fragment = this.get("fragment");
        const ViewClass = this.get("view");
        const viewOpts = this.get("viewOptions");
        let view;
    
        if (ViewClass) {
            view = new ViewClass(viewOpts);
            view.tabID = this.get("id");
        } else if (hasHistorySupport && fragment) {
            view = this.getTabViewByFragment();
        }
        
        return view;
    },
    
    /**
     * Get serialized representation of the tab as a plain object (w/o functions, blackjack, and hookers)
     * @returns {{}}
     */
    toTrackableJSON() {
        return _.omit(this.toJSON(), ["view", "viewOptions"]);
    }
});
